(function(){
    angular
        .module('appback')
        .directive('ngAcciones', accionesCont);

        accionesCont.$inject = ['HojaService','GenerallabService','$timeout', 'Upload'];
        function accionesCont(HojaService,GenerallabService,$timeout, Upload){
            return {
	            //require: 'ngModel',
              templateUrl: '/backend/hojafabricacion/template?name=accionescontenido.twig',
		          scope: {
                  //ngModel : '=',
                  //item: '=',
                  acciones:'=',
                  hojafabricacionactiva:'=',
                  fabricacionid: '=',
              	},
            	link: function (scope, element, $attrs) {
		            return $timeout(function () {
		            	console.log("fabricacionid",scope.fabricacionid);
                        scope.generalLab = GenerallabService;
						scope.nodeaccion = {};
						scope.resetInf = function(){
							scope.nodeaccion = {
								hojafabricacion_id: scope.fabricacionid,
								accion:"",
							};
						}
						scope.resetInf();

						scope.uploadFiles = function(files){
							if(files && files.length){
								for(var i = 0;i<files.length; i++){
									console.log("Fichero a subir", files[i]);
									Upload.upload({
										url: '/backend/hojafabricacion/subirficheroaccion',
										data: { file: files[i] }
									}).then(function(resp){
										console.log("response upload fichero", resp);
										if(resp.data.code > 0){
											if(angular.isUndefined(scope.nodeaccion.ficheros)){
												scope.nodeaccion.ficheros = [];
											}
											scope.nodeaccion.ficheros.push(resp.data);
										}else{
											console.log("Error al subir fichero", resp);
										}
									});
								}
							}else{
								console.log("No hay archivos para subir");
							}
						}

						scope.getExtraParams = function(){
							console.log("EXTRA PARAMS");
                            var extraparams = {"nodetype":"categoriaaccion","where":{"manual:=":"1"}};
                            return extraparams;
                        }

						scope.loading = false;
						scope.guardarAccion = function(){
							scope.loading = true;
							scope.code = 0;
                            scope.nodeaccion.hojafabricacion_id = scope.fabricacionid;
							console.log("nodeaccion",scope.nodeaccion);
							HojaService.setHojaFabricacionAccion(scope.nodeaccion,function(data){
                                //vm
								$timeout(function(){
                                    scope.hojafabricacionactiva.acciones = data.accioneshojafabricacion;
                                    scope.acciones = data.accioneshojafabricacion;
                                    scope.resetInf();
								})
								scope.loading = false;
								scope.code = data.code;
								scope.msg= data.msg;
							})
						}
			        });
		        }
          }
      }
})();